import React from "react";
import TextSearchNombreCliente from "../../atoms/text/text-serach-nombre-cliente/textSearchNombreCliente";
import "./textSearchBlockNombreCliente.scss";
const TextSearchBlockNombreCliente = (Props) => {
  return (
    <div className="TextSearchBlock">
      <TextSearchNombreCliente
        value={Props.value}
        onKeyUp={Props.onKeyUp}
        onChange={Props.onChange}
        data={Props.data}
        name={Props.name}
        placeholder={Props.placeholder}
        disabled={Props.disabled}
        autoComplete={Props.autoComplete}
        label={Props.label}
      />
    </div>
  );
};
export default TextSearchBlockNombreCliente;
